import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const label = event.target.closest(".shopping-chore-item")
    if (label) {
      label.classList.toggle("shopping-chore-item--checked", event.target.checked)
    }
    this.element.requestSubmit()
  }
}
